import { Box, Icon } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'
// Hooks
import { usePortal } from 'modules/core/lib/portalContext'

import useOverlimitEmployeesChecker from '../useOverlimitEmployeesChecker'
import styles from './index.module.scss'

interface Props {
  setUpgradeModalOpen: (value: boolean) => void
}

const OverlimitEmployeesFootNote = ({ setUpgradeModalOpen }: Props) => {
  const { closePortal } = usePortal()

  const { isOverlimit, currentSeats, limitEmployeesCurrentPlan } = useOverlimitEmployeesChecker()
  if (!isOverlimit) return null

  const onClick = () => {
    closePortal({
      preventOnCloseCallbackAfterClose: true,
    })

    setUpgradeModalOpen(true)
  }

  return (
    <Box flexDirection="row" alignItems="flexStart" gap="s8">
      <Box>
        <Icon.Medium icon="upgrade-plan" color="champagne1000" />
      </Box>
      {i18n.tView('overlimit_employees.foot_note.message', {
        currentSeats: <span>{currentSeats}</span>,
        limitEmployeesCurrentPlan: <span>{limitEmployeesCurrentPlan}</span>,

        upgradeLink: (
          <a className={styles.link} role="button" onClick={onClick}>
            {i18n.t('overlimit_employees.foot_note.link_text')}
          </a>
        ),
      })}
    </Box>
  )
}

export default observer(OverlimitEmployeesFootNote)
